// Written by scripts/vendor-pulse.sh: the content-hashed runtime URL.
export const RUNTIME_URL = '/pulse/pulse-8cf8b10cdc.umd.min.js';
